module.exports = __webpack_public_path__ + "img/DE00645.6b4baad1.png";